<template>
  <header class="site-header">
    <div class="sh-inner">
      <a class="brand" href="/">
        <span class="brand-name">Idle<b>Guild</b>Master</span>
      </a>

      <button class="nav-toggle" :class="{ open: navOpen }" @click="navOpen = !navOpen" :aria-expanded="navOpen" aria-label="menu">
        <span></span><span></span><span></span>
      </button>

      <div class="nav-backdrop" :class="{ open: navOpen }" @click="navOpen = false"></div>

      <nav class="site-nav" :class="{ open: navOpen }">
        <!-- 드로어 상단 도구 (≤550px에서만 노출) -->
        <div class="drawer-tools">
          <div class="lan_icon_wrapper" @click="change_lan()" title="language">
            <img class="lan_icon" :src="lanIcon" />
          </div>
          <button class="ic-btn" @click="toggleDarkMode">{{ isDarkMode ? '🌙' : '☀️' }}</button>
          <div class="btn_box" v-if="!except_route_list.includes(this.$route.name)">
            <a class="auth-btn" v-if="user_info.userid != ''" @click="logout()">{{ getTrans('logout') }}</a>
            <a class="auth-btn" v-else @click="login()">{{ getTrans('login') }}</a>
          </div>
        </div>
        <router-link v-for="s in sections" :key="s.path" :to="s.path" @click="navOpen = false">
          {{ currentLang === 'eng' ? s.eng : s.kor }}
        </router-link>
      </nav>

      <div class="sh-tools">
        <span class="ver" v-if="site_info.latest_update_version" :title="'Latest update: ' + site_info.latest_update_date">
          v{{ site_info.latest_update_version }}
        </span>
        <div class="lan_icon_wrapper" @click="change_lan()" title="language">
          <transition name="fade" mode="out-in">
            <img class="lan_icon" :key="lanIcon" :src="lanIcon" />
          </transition>
        </div>
        <button class="ic-btn" @click="toggleDarkMode" :title="isDarkMode ? 'Dark' : 'Light'">
          {{ isDarkMode ? '🌙' : '☀️' }}
        </button>
        <div class="btn_box" v-if="!except_route_list.includes(this.$route.name)">
          <a class="auth-btn" v-if="user_info.userid != ''" @click="logout()">{{ getTrans('logout') }}</a>
          <a class="auth-btn" v-else @click="login()">{{ getTrans('login') }}</a>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import axios from "axios";
import common from "@/common/common.js";
import config from "@/common/config.js";
export default {
  data: function () {
    return {
      isDarkMode: false,
      navOpen: false,
      user_info: { userid: "", username: "", nickname: "" },
      site_info: { latest_update_date: "", latest_update_version: "", app_version: "" },
      except_route_list: [
        "Join", "Login"
      ],
      sections: [
        { kor: "던전&레이드", eng: "Dungeon", path: "/map" },
        { kor: "아이템", eng: "Items", path: "/item" },
        { kor: "직업&특성", eng: "Class", path: "/class" },
        { kor: "펫", eng: "Pet", path: "/pet" },
        { kor: "시뮬레이터", eng: "Simulator", path: "/simulator/view" },
        { kor: "교리", eng: "Doctrine", path: "/doctrine" },
        { kor: "조합 공유", eng: "Team Deck", path: "/mapdeck" },
        { kor: "정보", eng: "Info", path: "/info" },
      ],
    }
  },
  computed: {
    lanIcon() {
      return this.$store.state.lan == 'kor' || this.$store.state.lan == 'KR'
        ? require('@/assets/lan_icon/kor.png')
        : require('@/assets/lan_icon/eng.png');
    },
    currentLang() {
      return this.$store.state.lan; // 또는 원하는 방식으로 현재 언어 상태 가져오기
    },
  },
  created() {
    // 사용자 설정 기억
    this.isDarkMode = localStorage.getItem('dark') === 'true';
    if (this.isDarkMode) {
      document.documentElement.classList.add('dark');
    }
  },
  methods: {
    toggleDarkMode() {
      this.isDarkMode = !this.isDarkMode;
      localStorage.setItem('dark', this.isDarkMode);
      document.documentElement.classList.toggle('dark', this.isDarkMode);
    },
    getTrans(type) {
      const translation = config.trans[type];
      if (translation) {
        return translation[this.currentLang] || translation['kor']; // 기본값으로 'kor' 선택
      }
      return type; // 기본값으로 type을 반환 (해당 번역이 없을 경우)
    },
    login() {
      location.href = '/login';
    },
    async logout() {
      let tm = this.getTrans('alert_logout');
      if (confirm(tm)) {
        let logout_result = await common.logout(this.$store.state.token);
        if (logout_result) {
          this.user_info = { userid: "", username: "", nickname: "" };
          this.$store.commit('set_token', ""); // 토큰 제거
          location.href = '/';
        }
      }
    },
    getSiteInfo() {
      axios({
        url: config.apiurl + "/system/site/getSettings",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        },
        method: "POST",
        data: {
          // token: this.$store.state.token,
        },
      })
        .then((response) => {
          let d = response.data;
          // console.log(d);
          if (d.result == 1) {
            this.site_info = d.site_info;
            // console.log(this.site_info);

            // 푸터에 표시할 웹사이트 버전(DB 값)을 store에 저장 → 즉시 반영
            this.$store.commit('set_app_version', d.site_info.app_version);
          }
        })
        .catch(function (error) {
          alert("오류가 발생했습니다...(getSettings)");
          console.log(error);
        });
    },
    change_lan() {
      this.$store.commit('change_lan');
    }
  },
  mounted: async function () {
    let user_info = await common.get_info(this.$store.state.token);

    if (user_info !== undefined) {
      this.user_info = user_info;
      this.$store.commit('set_user_info', user_info); // 유저정보 저장
    }

    this.getSiteInfo();
  },
};
</script>

<style scoped>
.site-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 50;
  background: var(--header-bg);
  border-bottom: 1px solid rgba(215, 165, 63, .18);
}
.site-header::after {
  content: "";
  position: absolute;
  left: 0; right: 0; bottom: -1px;
  height: 1px;
  background: linear-gradient(90deg, transparent, var(--accent-hi), transparent);
  opacity: .55;
}
.sh-inner {
  max-width: 1280px;
  margin: 0 auto;
  min-height: 72px;
  padding: 0 clamp(16px, 3vw, 36px);
  display: flex;
  align-items: center;
  gap: 22px;
}

/* 로고 */
.brand { display: flex; align-items: center; gap: 11px; flex: 0 0 auto; }
.brand-name {
  font-family: var(--font-display);
  font-size: 21px;
  font-weight: 700;
  letter-spacing: .01em;
  color: var(--header-text);
  white-space: nowrap;
}
.brand-name b { color: var(--accent-hi); font-weight: 700; }

/* 가로 네비 */
.site-nav { display: flex; align-items: center; gap: 2px; margin-right: auto; flex-wrap: nowrap; }
.site-nav a {
  padding: 8px 11px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  color: rgba(239, 233, 220, .72);
  white-space: nowrap;
  transition: color .18s, background .18s;
}
.site-nav a:hover { color: var(--header-text); background: rgba(255, 255, 255, .06); }
.site-nav a.router-link-active {
  color: var(--accent-hi);
  background: rgba(215, 165, 63, .14);
}

/* 우측 도구 */
.sh-tools { display: flex; align-items: center; gap: 10px; flex: 0 0 auto; }
.ver {
  font-size: 11.5px;
  color: rgba(239, 233, 220, .5);
  border: 1px solid rgba(239, 233, 220, .18);
  padding: 3px 8px;
  border-radius: 999px;
  white-space: nowrap;
}
.lan_icon_wrapper { width: 30px; height: 30px; cursor: pointer; flex: 0 0 auto; }
.lan_icon_wrapper .lan_icon { width: 100%; height: 100%; border-radius: 6px; }
.ic-btn {
  width: 34px; height: 34px;
  border-radius: 9px;
  border: 1px solid rgba(239, 233, 220, .18);
  background: rgba(255, 255, 255, .04);
  color: var(--header-text);
  cursor: pointer;
  display: grid; place-items: center;
  font-size: 14px;
  transition: border-color .18s;
}
.ic-btn:hover { border-color: var(--accent); }
.auth-btn {
  display: inline-block;
  height: 34px; line-height: 34px;
  padding: 0 16px;
  border-radius: 9px;
  font-size: 13.5px;
  font-weight: 600;
  color: #231a08;
  background: linear-gradient(180deg, var(--accent-hi), var(--accent));
  cursor: pointer;
  white-space: nowrap;
}
.auth-btn:hover { filter: brightness(1.06); }

/* 햄버거 (모바일) */
.nav-toggle {
  display: none;
  width: 40px; height: 40px;
  margin-left: auto;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
  background: none;
  border: 0;
  cursor: pointer;
  padding: 0 9px;
}
.nav-toggle span {
  display: block; height: 2px; width: 100%;
  background: var(--header-text);
  border-radius: 2px;
  transition: transform .25s ease, opacity .2s ease;
}
.nav-toggle.open span:nth-child(1) { transform: translateY(7px) rotate(45deg); }
.nav-toggle.open span:nth-child(2) { opacity: 0; }
.nav-toggle.open span:nth-child(3) { transform: translateY(-7px) rotate(-45deg); }

/* 백드롭 (데스크톱에선 숨김) */
.nav-backdrop { display: none; }

/* 드로어 상단 도구 (기본 숨김, ≤550px에서만 노출) */
.drawer-tools { display: none; }

/* 페이드 (언어 아이콘) */
.fade-enter-active, .fade-leave-active { transition: opacity 0.1s ease-in-out; }
.fade-enter-from, .fade-leave-to { opacity: 0; }

/* ===== 반응형: 우측 슬라이드 드로어 ===== */
@media (max-width: 1100px) {
  .brand { order: 0; }
  .sh-tools { order: 1; margin-left: auto; }
  .nav-toggle { display: flex; order: 2; margin-left: 8px; }

  .site-nav {
    position: fixed;
    top: 72px; right: 0;
    z-index: 60;
    height: calc(100vh - 72px);
    width: min(80vw, 300px);
    margin: 0;
    padding: 16px 14px 24px;
    box-sizing: border-box;
    background: var(--header-bg);
    border-left: 1px solid rgba(215, 165, 63, .22);
    box-shadow: -24px 0 48px -24px rgba(0, 0, 0, .6);
    flex-direction: column;
    align-items: stretch;
    flex-wrap: nowrap;
    gap: 4px;
    overflow-y: auto;
    transform: translateX(100%);
    transition: transform .28s ease;
  }
  .site-nav.open { transform: translateX(0); }
  .site-nav a { padding: 14px 16px; font-size: 15.5px; border-radius: 10px; color: rgba(239, 233, 220, .82); }

  .nav-backdrop {
    display: block;
    position: fixed;
    top: 72px; left: 0; right: 0; bottom: 0;
    z-index: 55;
    background: rgba(0, 0, 0, .5);
    opacity: 0;
    visibility: hidden;
    transition: opacity .28s ease, visibility .28s ease;
  }
  .nav-backdrop.open { opacity: 1; visibility: visible; }
}
/* ≤550px: 상단바의 언어/다크/로그인 숨기고 드로어 상단으로 이동 */
@media (max-width: 550px) {
  .sh-tools .lan_icon_wrapper,
  .sh-tools .ic-btn,
  .sh-tools .btn_box { display: none; }

  .drawer-tools {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 2px 4px 14px;
    margin-bottom: 8px;
    border-bottom: 1px solid rgba(215, 165, 63, .18);
  }
  .drawer-tools .btn_box { margin-left: auto; }
}
@media (max-width: 420px) {
  .brand-name { font-size: 18px; }
  .ver { display: none; }
  .sh-tools { gap: 7px; }
}
@media (prefers-reduced-motion: reduce) {
  .site-nav, .ic-btn, .site-nav a { transition: none; }
}
</style>
